import { Chart, Axis, BarSeries, Position, Settings } from '@elastic/charts';
import { customTheme } from './customTheme';

import * as S from './HorizontalBarGraph.styles';
import { SkeletonLoader } from 'components/Skeleton/SkeletonLoader';
import { ReactNode } from 'react';
import { MAIN } from 'theme';

export interface HorizontalBarGraphProps {
  title: string;
  data: { x: string; y: number }[];
  barSeriesName: string;
  color: keyof typeof MAIN;
  loading?: boolean;
}

function getChartHeight(x: number): number {
  switch (x) {
    case 0:
      return 50;
    case 1:
      return 100;
    case 2:
    case 3:
      return 120;
    default:
      return x * 40;
  }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ChartSkeleton = SkeletonLoader(S.Container as unknown as ReactNode) as any;
export const HorizontalBarGraph = ({
  loading,
  title,
  data,
  barSeriesName,
  color,
}: HorizontalBarGraphProps): JSX.Element => {
  return loading ? (
    <ChartSkeleton height="800px" />
  ) : (
    <S.Container>
      <S.Title>{title}</S.Title>
      {/* eslint-disable @typescript-eslint/ban-ts-comment */}
      {/*//@ts-ignore*/}
      <Chart size={['100%', getChartHeight(data.length)]}>
        <Settings
          rotation={90}
          legendSize={1}
          theme={{
            ...customTheme,
            colors: {
              vizColors: [`${MAIN[color]}B3`],
            },
          }}
        />
        <Axis id="count" position={Position.Left} />
        <Axis id="x" position={Position.Bottom} />
        <BarSeries id="bars" name={barSeriesName} xAccessor="x" yAccessors={['y']} data={data} />
      </Chart>
    </S.Container>
  );
};
